import { consola } from 'consola'
import { watch } from 'vue';
import { usePushNotificationSettings } from './usePushNotificationSettings';
import { useUserProfileStore } from '@entities/user';
import { useModalStore } from '@shared/model';

/**
 * Инициализирует push-уведомления при первом входе пользователя.
 *
 * Должен вызываться один раз в плагине или корневом layout-компоненте.
 * Следит за переходом user.id из 0 → ненулевое значение (первая загрузка профиля).
 */
export const usePushNotificationInit = () => {
  if (!process.client) return;

  const userProfileStore = useUserProfileStore();
  const pushSettings = usePushNotificationSettings();
  const modalStore = useModalStore();

  watch(
    () => userProfileStore.user.id,
    async (newId, prevId) => {
      const isFirstLoad = (!prevId || prevId === 0) && newId && newId > 0;
      if (!isFirstLoad) return;

      try {
        await pushSettings.initPushNotificationsAfterAuth();
      } catch (error) {
        consola.warn('[usePushNotificationInit] Failed to initialize push notifications:', error);
      }
    },
  );

  // Пуш-промпт новичка показываем в финале онбординга. После регистрации флаг
  // onboardingPushPending взведён, а вся цепочка модалок (регистрация → подтверждение
  // телефона → благодарность → карта) держит modalStore.isOpen === true. Первое закрытие
  // модалки после регистрации = пользователь добавил адрес ИЛИ нажал «Не сейчас» —
  // именно тут «железобетонно» показываем запрос на уведомления.
  watch(
    () => modalStore.isOpen,
    (isOpen, wasOpen) => {
      if (wasOpen && !isOpen && pushSettings.isOnboardingPushPending()) {
        pushSettings.showOnboardingPushPrompt().catch((error) => {
          consola.warn('[usePushNotificationInit] Failed to show onboarding push prompt:', error);
        });
      }
    },
  );
};
